﻿export const removeLeadingForwardSlash = (value: string): string =>
  value?.replace(/^\//, "");
